export function formatDateWithoutTime(format: string): string {
  const formatsWithoutTime: { [index: string]: string } = {
    'DD/MM/YYYY, hh:mm A': 'DD/MM/YYYY',
    'MM/DD/YYYY, hh:mm A': 'MM/DD/YYYY'
  };

  return formatsWithoutTime[format] || format;
}
